class UGCCarousel extends HTMLElement {
  constructor() {
    super();

    const positions = [-2, -1, 0, 1, 2]; // Visible positions possible
    const slides = Array.from(this.querySelectorAll('.ugc-carousel__slide'));
    const positionsMissing = positions.length <= slides.length ? 0 : positions.length - slides.length;

    this.positions = this.removeAlternating(positions, positionsMissing);
    this.currentOrder = [...slides];
    this.autoplayFirstVideo = this.dataset.autoplayFirstVideo === 'true';
    this.readyToAutoplay = false;
    this.hasAutoplayed = false;

    this.render();

    if (this.autoplayFirstVideo) this.observeAutoplay();

    this.querySelector('.ugc-carousel__next').addEventListener('click', this.nextClick.bind(this));
    this.querySelector('.ugc-carousel__prev').addEventListener('click', this.prevClick.bind(this));
    slides.forEach(slide => {
      slide.addEventListener('click', this.slideClick.bind(this));
    });
  }

  render() {
    let activeSlide = null;
    this.currentOrder.forEach((slide, i) => {
      if (i < this.positions.length) {
        slide.dataset.pos = this.positions[i];
        if (slide.dataset.pos == 0) {
          activeSlide = slide;
        }
      } else {
        slide.dataset.pos = "hidden";
      }
    });

    if (activeSlide) {
      this.pauseOtherVideos(activeSlide.querySelector('video'));

      if (this.autoplayFirstVideo && this.readyToAutoplay && !this.hasAutoplayed) {
        const deferredMedia = activeSlide.querySelector('deferred-media');
        if (deferredMedia) {
          this.hasAutoplayed = true;
          deferredMedia.loadContent(false);

          // Browsers block autoplay of unmuted video outside a user gesture (e.g. a click),
          // so a scroll-triggered play needs to start muted or it gets silently rejected.
          const video = deferredMedia.querySelector('video');
          if (video) {
            video.muted = true;
            video.play().catch(() => {});
          }
        }
      }
    }
  }

  removeAlternating(arr, numToRemove) {
    for (let i = 0; i < numToRemove; i++) {
      if (arr.length === 0) break;
      if (i % 2 !== 0) {
        arr.pop();
      } else {
        arr.shift();
      }
    }
    return arr;
  }

  nextClick() {
    this.moveSlider(true);
    this.render();
  }

  prevClick() {
    this.moveSlider(false);
    this.render();
  }

  observeAutoplay() {
    this.autoplayObserver = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.readyToAutoplay = true;
        this.render();
      },
      { threshold: 0.5 }
    );
    this.autoplayObserver.observe(this);
  }

  pauseOtherVideos(targetedVideo) {
    const allVideos = this.querySelectorAll('video');
    allVideos.forEach(video => {
      if (video !== targetedVideo) {
        video.pause();
        video.removeAttribute('controls');
        video.classList.add('paused-video');
      } else {
        video.classList.remove('paused-video');
        video.setAttribute('controls', 'controls');
      }
    });
  }

  moveSlider(next = true) {
    if (next) {
      const first = this.currentOrder.shift();
      this.currentOrder.push(first);
    } else {
      const last = this.currentOrder.pop();
      this.currentOrder.unshift(last);
    }
  }

  slideClick(e) {
    const clickedSlide = e.currentTarget;
    const currentIndex = this.currentOrder.indexOf(clickedSlide);
    const zeroIndex = this.positions.indexOf(0);

    if (currentIndex === -1 || zeroIndex === -1) return;

    // Find shortest direction
    let diff = currentIndex - zeroIndex;
    const length = this.currentOrder.length;
    if (Math.abs(diff) > length / 2) {
      diff = diff > 0 ? diff - length : diff + length;
    }

    if (diff > 0) {
      for (let i = 0; i < diff; i++) {
        this.moveSlider(true);
      }
    } else if (diff < 0) {
      for (let i = 0; i < Math.abs(diff); i++) {
        this.moveSlider(false);
      }
    }
    this.render();
  }

}

customElements.define('ugc-carousel', UGCCarousel);